import EmailPasswordForm from './EmailPasswordForm';

export default EmailPasswordForm;
